<template>
  <TextField
    :id="id"
    v-model="model.name"
    :name="name"
    :label="label"
    :rules="rules"
    type="text"
    :input-class="inputClass"
    :error-class="errorClass"
    :blur="onInputBlur"
    :mouse-over="onMouseOver"
    :mouse-out="onMouseOut"
    :moduleName="moduleNameValue"
    :foundryId="foundryIdValue"
    :description="model.name"
    @update-banned-word="bannedWordForStyle"
    :placeholder="placeholder"
    :show-error-message="showErrorMessage"
  />
</template>

<script setup>
import { ref } from 'vue'
import TextField from 'src/components/form/text-field/index.vue'

const props = defineProps({
  modelValue: {
    type: [Function, Object],
    default: () => ({
      id: '',
      name: '',
      required: true
    })
  },
  defaultValue: {
    type: [String, Number],
    default: ''
  },
  inputClass: {
    type: [Function, Array],
    default: () => []
  },  
  errorClass: {
    type: [String, Object, Array],
    default: () => []
  },
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: ''
  },
  rules: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  showErrorMessage: {
    type: Boolean,
    default: false
  },
  moduleNameValue: {
    type: String,
    default: ''
  },
  foundryIdValue: {
    type: String,
    default: ''
  },
})

const emit = defineEmits(['blur', 'mouseover', 'mouseout', 'banned-word-exist'])

const model = ref({ ...props.modelValue })
const flag = ref(false)

const bannedWordForStyle = value => {
  flag.value = value
  emit('banned-word-exist', flag.value)
}

const onInputBlur = event => {
  const { value } = event.target
  if (!value) {
    model.value.name = props.defaultValue
  }
  emit('blur', model.value)
}

const onMouseOver = event => {
  emit('mouseover', event)
}

const onMouseOut = event => {
  emit('mouseout', event)
}
</script>
